import {
  TESTIMONIAL_LIST_LOADING,
  GET_TESTIMONIAL_LIST_ERROR,
  GET_TESTIMONIAL_LIST,
  GET_TESTIMONIAL_BY_ID_LOADING,
  GET_TESTIMONIAL_BY_ID_SUCCESS,
  GET_TESTIMONIAL_BY_ID_ERROR,
  DELETEING_TESTIMONIAL,
  DELETE_TESTIMONIAL,
  DELETE_TESTIMONIAL_ERROR,
  DELETED_TESTIMONIAL_LIST_LOADING,
  GET_DELETED_TESTIMONIAL_LIST,
  GET_DELETED_TESTIMONIAL_LIST_ERROR,
  PERMA_DELETEING_TESTIMONIAL,
  PERMA_DELETE_TESTIMONIAL,
  PERMA_DELETE_TESTIMONIAL_ERROR,
  RESTORE_TESTIMONIAL_LIST_LOADING,
  RESTORE_TESTIMONIAL_LIST,
  RESTORE_TESTIMONIAL_LIST_ERROR,
} from "./types";

const INITIAL_STATE = {
  data: undefined,
  loading: false,
  error: false,
  dataById: undefined,
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case TESTIMONIAL_LIST_LOADING:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case GET_TESTIMONIAL_BY_ID_LOADING:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case DELETEING_TESTIMONIAL:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case DELETED_TESTIMONIAL_LIST_LOADING:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case PERMA_DELETEING_TESTIMONIAL:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case RESTORE_TESTIMONIAL_LIST_LOADING:
      return {
        ...state,
        loading: true,
        error: false,
      };

    case GET_TESTIMONIAL_LIST:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        error: false,
      };
    case GET_TESTIMONIAL_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        dataById: action.payload.data,
        error: false,
      };
    case GET_DELETED_TESTIMONIAL_LIST:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        error: false,
      };
    case DELETE_TESTIMONIAL:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        error: false,
      };

    case PERMA_DELETE_TESTIMONIAL:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        error: false,
      };
    case RESTORE_TESTIMONIAL_LIST:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        error: false,
      };

    case GET_TESTIMONIAL_LIST_ERROR:
      return {
        ...state,
        data: undefined,
        loading: false,
        error: action.payload.data,
      };
    case GET_TESTIMONIAL_BY_ID_ERROR:
      return {
        ...state,
        dataById: undefined,
        loading: false,
        error: action.payload.data,
      };
    case GET_DELETED_TESTIMONIAL_LIST_ERROR:
      return {
        ...state,
        dataById: undefined,
        loading: false,
        error: action.payload.data,
      };
    case DELETE_TESTIMONIAL_ERROR:
      return {
        ...state,
        data: undefined,
        loading: false,
        error: action.payload.data,
      };
    case PERMA_DELETE_TESTIMONIAL_ERROR:
      return {
        ...state,
        data: undefined,
        loading: false,
        error: action.payload.data,
      };
    case RESTORE_TESTIMONIAL_LIST_ERROR:
      return {
        ...state,
        data: undefined,
        loading: false,
        error: action.payload.data,
      };

    default:
      return state;
  }
};

export default reducer;